import type { ReactNode } from 'react'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'error' | 'info'

interface BadgeProps {
  readonly tone?: BadgeTone
  readonly children: ReactNode
  readonly className?: string
}

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-parchment text-charcoal',
  success: 'bg-success/20 text-success',
  warning: 'bg-bamboo/30 text-charcoal',
  error: 'bg-terra/20 text-terra',
  info: 'bg-forest/10 text-forest'
}

export function Badge({ tone = 'neutral', children, className = '' }: BadgeProps): JSX.Element {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-micro font-body font-medium ${TONE[tone]} ${className}`.trim()}
    >
      {children}
    </span>
  )
}
